import React from 'react'
import Layout from '../layouts/Layout'
import Hero from '../components/camps/Hero'
import FeatureBar from '../components/camps/FeatureBar'
import CTASection from '../components/CTASection'
import CampsCourses from '../components/camps/CampsCourses'
import AdvantagesSection from '../components/camps/AdvantagesSection'

const WinterCamps = () => {
  return (
    <Layout>
      <Hero bg="bg-[#923D8C]" title="Winter Camp"/>
       <FeatureBar />
      <CampsCourses />
      <div className="bg-[#f5f5f5] pt-[75px] pb-20 ">
        <CTASection
          title="Warm Up Your Winter With Coding"
          textSize="text-5xl"
          subText="Join our winter camp and turn chilly days into cool projects!"
          btnText="Claim your Spot Now"
          btnSize="px-[54.5px]"
          isAddToCartVisible={false}
        />
      </div>
      <AdvantagesSection/>
    </Layout>
  )
}

export default WinterCamps
